module.exports = __webpack_public_path__ + "images/5cc34d18d8eb1660de57c242e1913826-classroom1.jpg";